import React from "react";
import Pill from "../Pill";

export interface NewBadgeProps {
  /** White pill with ink text, for use on a selected (tinted) row. */
  inverted?: boolean;
  /** Visible text. Defaults to "New" (rendered uppercase). */
  label?: string;
}

/** Small "NEW" pill marking a newly released report / feature. */
export default function NewBadge({
  inverted = false,
  label = "New",
}: NewBadgeProps) {
  return (
    <Pill tone={inverted ? "inkInverted" : "ink"} uppercase>
      {label}
    </Pill>
  );
}
